module.exports = __webpack_public_path__ + "img/logo.90d43629.png";